function buildMapLink(address) {
  if (!address)
    return null;
  return 'https://maps.google.com/?q=' + encodeURIComponent(address.replace(/\n/g, ' '));
}

export { buildMapLink };
